var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watermark"},[_c('span',{ref:"mark",staticClass:"mark"},[_vm._v(_vm._s(_vm.mark))])])
}
var staticRenderFns = []

export { render, staticRenderFns }